const state = () => ({
  isValid: false,
  birthDate: null,
  gender: null,
  language: null
});

const getters = {
  isValid(state) {
    return state.isValid;
  },
  birthDate(state) {
    return state.birthDate;
  },
  gender(state) {
    return state.gender;
  },
  language(state) {
    return state.language;
  }
};

const mutations = {
  setIsValid(state, payload) {
    state.isValid = payload;
  },
  updateBirthDate(state, payload) {
    state.birthDate = payload;
  },
  updateGender(state, payload) {
    state.gender = payload;
  },
  updateLanguage(state, payload) {
    state.language = payload;
  }
};

export const preventionInfo = {
  state,
  getters,
  mutations,
  namespaced: true
};
